module.exports = __webpack_public_path__ + "static/3-Agency-cover-45e22d00f7c3a18d631e00024b071791.png";